import {
  Badge,
  Box,
  Card,
  Text,
  TextField,
  InlineStack,
  Button,
  OptionList,
  Popover,
  BlockStack,
  Thumbnail,
  Tooltip,
  Banner,
} from "@shopify/polaris";
import {
  PlusIcon,
  MinusCircleIcon,
  DuplicateIcon,
} from "@shopify/polaris-icons";
import React, { useState } from "react";
import SwitchButton from "../../../OrderFulfillment/components/SwitchButton";

const BasicPriceBox = ({pageData,setPageData,toastFun}) => {
  const options = [
    {
      label: (
        <span
          style={{
            textAlign: "center",
            width: "36px",
            display: "inline-block",
            fontSize: "18px",
            fontWeight: 650,
          }}
        >
          +
        </span>
      ),
      value: 2,
    },
    {
      label: (
        <span
          style={{
            textAlign: "center",
            width: "36px",
            display: "inline-block",
            fontSize: "18px",
            fontWeight: 650,
          }}
        >
         ×
        </span>
      ),
      value: 1,
    },
  ];
  const [formatOpen, setFormatOpen] = useState({
    type:'',
    val:-1
  });
  // 价格规则开关
  const handlePriceRuleSwitch = (type) => {
    setPageData(prev=>{
      let params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          [type]:prev.advanced_rule[type] ? 0 : 1
        }
      }
      if (type === 'is_price_range_on') {
        if (params?.advanced_rule?.is_price_range_on === 1) {
          toastFun('Enabled successfully')
        }else {
          toastFun('Disabled successfully')
        }
      }
      return params;
    })
  };
  // 判断是否存在价格区间设置不合格
  const [isCostError, setIsCostError] = useState({
    tip:'',
    index: -1
  });
  // 价格范围设置
  const handlePriceRange = (index,type,val) => { 
    if (val.length > 10 ) return; 
    let value = val
         // 过滤非法字符并处理格式
        value = value.replace(/[^0-9.]/g, '');
        value = value.replace(/\.{2,}/g, '.'); // 防止多个小数点
        const parts = value.split('.');
        
        // 处理小数部分
        if (parts.length > 1) {
        value = parts[0] + '.' + parts[1].slice(0, 2);
        }
        // 防止以0开头的整数（可选）
        if (parts[0]?.length > 1 && parts[0][0] === '0') {
        value = parts[0].substr(1) + (parts[1] ? `.${parts[1]}` : '');
        }
        setPageData(prev=>{
          let params = {
            ...prev,
            advanced_rule:{
              ...prev.advanced_rule,
              price_range:{
                ...prev.advanced_rule.price_range,
                cost_range:prev.advanced_rule.price_range.cost_range.map((item,i)=>{
                  if(i===index){
                    return {
                      ...item,
                      [type]:value
                    }
                  }else{
                    return item
                  }
                })
              }
            }
          }
          let data = params.advanced_rule.price_range.cost_range;
          let hasError = false;

          // 1. 检查每个区间本身的合法性（Start_Range_Value >= End_Range_Value）
          for (let i = 0; i < data.length; i++) {
            if (Number(data[i].Start_Range_Value) >= Number(data[i].End_Range_Value)) {
              hasError = true;
              setIsCostError({
                index:i,
                tip:'Cost range end value must be greater than the starting value.'
              })
              break;
            }
          }
          
          // 2. 检查区间之间是否有重叠（只有当前面检查通过时才进行）
          if (!hasError) {
            // 先按Start_Range_Value排序以便比较
            const sortedData = [...data].sort((a, b) => a.Start_Range_Value - b.Start_Range_Value);
            
            for (let i = 1; i < sortedData.length; i++) {
              if (sortedData[i-1].End_Range_Value > sortedData[i].Start_Range_Value) {
                setIsCostError({
                  index:i,
                  tip:'Your ranges overlap.'
                })
                hasError = true;
                break;
              }
            }
          }
          if (!hasError) {
            setIsCostError({
              index:-1,
              tip:''
            })
          }
          return params;
        })
    
  };
  // 价格设置子项新增
  const handleAddPriceRange = () => {
    setPageData((prev) => {
      // 获取当前cost_range数组，处理可能不存在的情况
      const costRange = prev.advanced_rule?.price_range?.cost_range || [];
       // 收集所有有效的Start和End值
       const allValues = costRange.flatMap(({ Start_Range_Value, End_Range_Value }) => [
        Start_Range_Value,
        End_Range_Value
      ]).filter(value => typeof value === 'number'); // 确保值为数字类型

      // 计算最大值，若数组为空则maxValue为null
      const maxValue = allValues.length > 0 ? Math.max(...allValues) : null;
      let newStart, newEnd;
  
        const lastEnd = maxValue || 0;
  
      if (costRange.length === 0) {
        // 数组为空，使用默认值
        newStart = 0.1;
        newEnd = 0.2;
      } else {
        if (typeof lastEnd === 'number') {
          // 存在End，按原逻辑递增
          newStart = lastEnd + 0.1;
          newEnd = lastEnd + 0.2;
        }else {
          // 两者都不存在，使用默认值
          newStart = 0.1;
          newEnd = 0.2;
        }
      }
  // 转换回浮点数并修复精度
  const formatNumber = (num) => 
    Number(num.toFixed(2));
      // 构建新的price_range对象
      const newPriceRange = {
        ...prev.advanced_rule?.price_range,
        cost_range: [
          ...costRange,
          {
            "Start_Range_Value": formatNumber(newStart),
            "End_Range_Value": formatNumber(newEnd),
            "Factor_Value": 2,
            "Factor_Mark": 2,
            "isComparedPriceMarkup": 1,
            "ComparedPrice_Factor_Value": "",
            "ComparedPrice_Factor_Mark": 2,
            "isEndRow": 0
          }
        ]
      };
  
      // 合并到新的state
      return {
        ...prev,
        advanced_rule: {
          ...prev.advanced_rule,
          price_range: newPriceRange
        }
      };
    });
   
  };
  // 价格设置子项复制 
  const handleCopyPriceRange = (item) => {
    setPageData((prev) => {
      // 获取当前cost_range数组，处理可能不存在的情况
      const costRange = prev.advanced_rule?.price_range?.cost_range || [];
      // 收集所有有效的Start和End值
      const allValues = costRange.flatMap(({ Start_Range_Value, End_Range_Value }) => [
        Start_Range_Value,
        End_Range_Value
      ]).filter(value => typeof value === 'number'); // 确保值为数字类型

      // 计算最大值，若数组为空则maxValue为null
      const maxValue = allValues.length > 0 ? Math.max(...allValues) : null;
      let newStart, newEnd;
  
        const lastEnd = maxValue || 0;
  
        if (typeof lastEnd === 'number') {
          // 存在End，按原逻辑递增
          newStart = lastEnd + 0.1;
          newEnd = lastEnd + 0.2;
        } else {
          // 两者都不存在，使用默认值
          newStart = 0.1;
          newEnd = 0.2;
      }
  // 转换回浮点数并修复精度
  const formatNumber = (num) => 
    Number(num.toFixed(2));
      // 构建新的price_range对象
      const newPriceRange = {
        ...prev.advanced_rule?.price_range,
        cost_range: [
          ...prev.advanced_rule?.price_range.cost_range,
          {
            "Start_Range_Value": formatNumber(newStart),
            "End_Range_Value": formatNumber(newEnd),
            "Factor_Value": item.Factor_Value,
            "Factor_Mark": item.Factor_Mark,
            "isComparedPriceMarkup": 1,
            "ComparedPrice_Factor_Value": item.ComparedPrice_Factor_Value,
            "ComparedPrice_Factor_Mark": item.ComparedPrice_Factor_Mark,
            "isEndRow": 0
          }
        ]
      };
  
      // 合并到新的state
      return {
        ...prev,
        advanced_rule: {
          ...prev.advanced_rule,
          price_range: newPriceRange
        }
      };
    });
    toastFun('Copied Successfully')
  }; 
  // 价格系数设置

  const handlePriceMark = (index,type,val,isReset) => { 
    if (type === 'price_mark' || type === 'price_factor' || type === 'compared_price_factor' || type === 'compared_price_mark') {
      setPageData(prev=>{
        let params = {
          ...prev,
          advanced_rule:{
            ...prev.advanced_rule,
            basic_price:{
              ...prev.advanced_rule.basic_price,
              [type]:Number(val) 
            }
          }
        }
        return params;
      })
    }else {
    setPageData(prev=>{
      let params = {...prev}
      if (isReset) {
        params = {
          ...prev,
          advanced_rule:{
            ...prev.advanced_rule,
            price_range:{
              ...prev.advanced_rule.price_range,
              rest_range:{
                ...prev.advanced_rule.price_range.rest_range,
                [type]:Number(val)
              }
            }
          }
        }
      }else {
        params = {
          ...prev,
          advanced_rule:{
            ...prev.advanced_rule,
            price_range:{
              ...prev.advanced_rule.price_range,
              cost_range:prev.advanced_rule.price_range.cost_range.map((item,i)=>{
                if(i===index){
                  return {
                    ...item,
                    [type]:Number(val) 
                  }
                }else{
                  return item
                }
              })
            }
          }
        }
      }
      
      return params;
    })
  }
    setFormatOpen({
      type: '',
      val:-1
    });
    
  };
  // 修改价格系数和对比价
  const onChangePrice = (index,type,val,isReset)=>{
    if (val.length > 10 ) return; 
    let value = val;
     // 过滤非法字符并处理格式
    value = value.replace(/[^0-9.]/g, '');
    value = value.replace(/\.{2,}/g, '.'); // 防止多个小数点
    const parts = value.split('.');
    
    // 处理小数部分
    if (parts.length > 1) {
    value = parts[0] + '.' + parts[1].slice(0, 2);
    }
    // 防止以0开头的整数（可选）
    if (parts[0]?.length > 1 && parts[0][0] === '0') {
    value = parts[0].substr(1) + (parts[1] ? `.${parts[1]}` : '');
    }
    if (type === 'price_mark' || type === 'price_factor' || type === 'compared_price_factor' || type === 'compared_price_mark') {
      setPageData(prev=>{
        let params = {
          ...prev,
          advanced_rule:{
            ...prev.advanced_rule,
            basic_price:{
              ...prev.advanced_rule.basic_price,
              [type]:value
            }
          }
        }
        return params;
      })
    }else {
      
      setPageData(prev=>{
        let params = {}
        if (isReset) {
        params = {
          ...prev,
          advanced_rule:{
            ...prev.advanced_rule,
            price_range:{
              ...prev.advanced_rule.price_range,
              rest_range:{
                ...prev.advanced_rule.price_range.rest_range,
                [type]:value
              }
            }
          }
        }
      }else {
        params = {
          ...prev,
          advanced_rule:{
            ...prev.advanced_rule,
            price_range:{
              ...prev.advanced_rule.price_range,
              cost_range:prev.advanced_rule.price_range.cost_range.map((item,i)=>{
                if(i===index){
                  return {
                    ...item,
                    [type]:value
                  }
                }else{
                  return item
                }
              })
            }
          }
        }
      }
      return params;
    })
  }
}

 // 失焦重置
 const onChangePriceBlur = (index,type,val,isReset)=>{
  let value = val;

// 处理边界情况
if (value === '' || value === '.') {
  if (type === 'price_mark' || type === 'price_factor' || type === 'compared_price_factor' || type === 'compared_price_mark') {
    setPageData(prev=>{
      let params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          basic_price:{
            ...prev.advanced_rule.basic_price,
            [type]:1
          }
        }
      }
      return params;
    })
  }else {
  setPageData(prev=>{
    let params = {}
    if (isReset) {
      params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          price_range:{
            ...prev.advanced_rule.price_range,
            rest_range:{
              ...prev.advanced_rule.price_range.rest_range,
              [type]:1
            }
          }
        }
      }
    }else {
      params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          price_range:{
            ...prev.advanced_rule.price_range,
            cost_range:prev.advanced_rule.price_range.cost_range.map((item,i)=>{
              if(i===index){
                return {
                  ...item,
                  [type]:1
                }
              }else{
                return item
              }
            })
          }
        }
      }
    }
    return params;
  })
}
return;
}

// 补充前导零
if (value.startsWith('.')) {
value = '0' + value;
}
const numericValue = parseFloat(value);
// 数值验证
if (isNaN(numericValue) || numericValue <= 0) {
  if (type === 'price_mark' || type === 'price_factor' || type === 'compared_price_factor' || type === 'compared_price_mark') {
    setPageData(prev=>{
      let params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          basic_price:{
            ...prev.advanced_rule.basic_price,
            [type]:1
          }
        }
      }
      return params;
    })
  }else {
  setPageData(prev=>{
    let params = {}
    if (isReset) {
      params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          price_range:{
            ...prev.advanced_rule.price_range,
            rest_range:{
              ...prev.advanced_rule.price_range.rest_range,
              [type]:1
            }
          }
        }
      }
    }else {
      params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          price_range:{
            ...prev.advanced_rule.price_range,
            cost_range:prev.advanced_rule.price_range.cost_range.map((item,i)=>{
              if(i===index){
                return {
                  ...item,
                  [type]:1
                }
              }else{
                return item
              }
            })
          }
        }
      }
    }
    return params;
  })
}
} else {
// 格式化显示
let formatted = numericValue.toFixed(2)
  .replace(/\.00$/, '')
  .replace(/(\.\d)0$/, '$1');
  if (type === 'price_mark' || type === 'price_factor' || type === 'compared_price_factor' || type === 'compared_price_mark') {
    setPageData(prev=>{
      let params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          basic_price:{
            ...prev.advanced_rule.basic_price,
            [type]:formatted
          }
        }
      }
      return params;
    })
  }else {
  setPageData(prev=>{
    
    let params = {}
    if (isReset) {
      params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          price_range:{
            ...prev.advanced_rule.price_range,
            rest_range:{
              ...prev.advanced_rule.price_range.rest_range,
              [type]:formatted
            }
          }
        }
      }
    }else {
      params = {
        ...prev,
        advanced_rule:{
          ...prev.advanced_rule,
          price_range:{
            ...prev.advanced_rule.price_range,
            cost_range:prev.advanced_rule.price_range.cost_range.map((item,i)=>{
              if(i===index){
                return {
                  ...item,
                  [type]:formatted
                }
              }else{
                return item
              }
            })
          }
        }
      }
    }
    return params;
  })
}
}
}
// 价格子项移除
const handlePriceItemRemove = (index) => {
  setPageData(prev=>{
    let params = {
      ...prev,
      advanced_rule:{
        ...prev.advanced_rule,
        price_range:{
          ...prev.advanced_rule.price_range,
          cost_range:prev.advanced_rule.price_range.cost_range.filter((item,i)=>i!==index)
        }
      }
    }
    return params;
  })
  toastFun('Deleted Successfully')
}
  // 示例价格
  const [testPrice,setTestPrice] = useState({
    cost:0,
    fee:0
  })
  const onChangeTestPrice = (type,val)=>{
    if (val.length > 10 ) return; 
    let value = val;
     // 过滤非法字符并处理格式
    value = value.replace(/[^0-9.]/g, '');
    value = value.replace(/\.{2,}/g, '.'); // 防止多个小数点
    const parts = value.split('.');
    
    // 处理小数部分
    if (parts.length > 1) {
    value = parts[0] + '.' + parts[1].slice(0, 2);
    }
    // 防止以0开头的整数（可选）
    if (parts[0]?.length > 1 && parts[0][0] === '0') {
    value = parts[0].substr(1) + (parts[1] ? `.${parts[1]}` : '');
    }
    setTestPrice(preValue=>({
      ...preValue,
      [type]:value
    }))
  }
  const onChangeTestPriceBlur = (type,val)=>{
    if (val === '' || val === '.') {
      setTestPrice(preValue=>({
        ...preValue,
        [type]:0
      }))
      return;
    }
    // 补充前导零
    if (val.startsWith('.')) {
      val = '0' + val;
      }
  const numericValue = parseFloat(val);
  // 数值验证
  if (isNaN(numericValue) || numericValue <= 0) {
    setTestPrice(preValue=>({
      ...preValue,
      [type]:0
    }))
  }
  }
  // 示例价格
  const handleExamplePrice = (type) => {
    const { cost, fee } = testPrice;
    const { advanced_rule } = pageData || {};
    const { shipping_fee_on, assign_cents } = advanced_rule || {};
    
    let price = Number(cost) || 0;
    // 处理价格系数规则
  const currentValue = Number(cost);
  let matchedRule =  pageData?.advanced_rule?.price_range?.rest_range;
  if (pageData?.advanced_rule?.is_price_range_on) {
    matchedRule = pageData?.advanced_rule?.price_range?.cost_range.find(({ Start_Range_Value, End_Range_Value }) => {
      const start = Number(Start_Range_Value);
      const end = Number(End_Range_Value);
      return currentValue >= start && (isNaN(end) || currentValue <= end);
    }) || pageData?.advanced_rule?.price_range?.rest_range;
  }else {
    matchedRule = {
      Factor_Mark:pageData?.advanced_rule?.basic_price?.price_mark,
      Factor_Value:pageData?.advanced_rule?.basic_price?.price_factor
    }
  }
  
  if (matchedRule) {
    const isCostType = type === 'cost';
    const factorMark = isCostType ? matchedRule.Factor_Mark : matchedRule.ComparedPrice_Factor_Mark;
    const factorValue = isCostType ? matchedRule.Factor_Value : matchedRule.ComparedPrice_Factor_Value;
    
    // 转换为数字类型
    const numFactorValue = Number(factorValue) || 0;
    
    // 应用系数规则
    price = (factorMark === "1" || factorMark === 1)
      ? price * numFactorValue 
      : price + numFactorValue;
  }
  // 如果存在使用运费，则加上运费
  if (shipping_fee_on === 1) {
    price += Number(fee);
  }
    // 处理价格后缀
    if (assign_cents?.switch === 1) {
      const cents = type === 'cost' 
        ? assign_cents.price 
        : assign_cents.compared_price;
      price = `${Math.trunc(price)}.${cents}`;
    } else {
      price = price.toFixed(2);
    }
    let showPrice = '$ '+ price; 
    
    return showPrice;
  };
  

  let showPrice = pageData?.advanced_rule?.is_price_range_on;
  let showShippFee = pageData?.advanced_rule?.shipping_fee_on;
  let showOriginal = pageData?.advanced_rule?.is_compared_price_on;
  
  return (
    <Box>
      <BlockStack gap={400}>
        <Card padding={0} roundedAbove="xs">
          <Box
            style={{ background: "rgba(247, 247, 247, 1)", padding: "16px" }}
          >
            <BlockStack gap={400}>
              <Box>
                <Text variant="headingSm" as="h6">
                  Pricing Rule
                </Text>
              </Box>
              <Box className="advanced_rule_box_switch">
                <InlineStack gap={400} blockAlign="center">
                  <InlineStack gap={200} blockAlign="center" align="space-between">
                    <span style={{flex:1}}>Apply for different price</span>
                    <SwitchButton open={pageData?.advanced_rule?.is_price_range_on === 1} handleSwitch={() => {
                      handlePriceRuleSwitch('is_price_range_on')
                    }} />
                  </InlineStack>
                  <InlineStack gap={200} blockAlign="center" align="space-between">
                    <span>Add shipping fee</span>
                    <SwitchButton open={pageData?.advanced_rule?.shipping_fee_on === 1} handleSwitch={() => {
                      handlePriceRuleSwitch('shipping_fee_on')
                    }} />
                  </InlineStack>
                  <InlineStack gap={200} blockAlign="center" align="space-between">
                    <span>Add original price</span>
                    <SwitchButton open={pageData?.advanced_rule?.is_compared_price_on === 1} handleSwitch={() => {
                      handlePriceRuleSwitch('is_compared_price_on')
                    }} />
                  </InlineStack>
                </InlineStack>
              </Box>
              {showPrice ? "" :<Card roundedAbove="xs">
                  <Box>
                    <BlockStack gap={400}>
                      <Box>
                        <InlineStack gap={100} blockAlign="center">
                          <span>Selling price =</span>
                          <span className="price_coefficient_badge">
                            <Badge tone="info"><span className='color1_price'>Product cost</span></Badge>
                          </span>
                          <Box className="price_coefficient_operator">
                            <Popover
                              active={formatOpen?.type === 'price_mark' && formatOpen?.val === 997}
                              activator={
                                <Button
                                  disclosure="select"
                                  onClick={() => {
                                    setFormatOpen({
                                      type: 'price_mark',
                                      val:997
                                    });
                                  }}
                                >
                                  {Number(pageData?.advanced_rule?.basic_price?.price_mark) === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                                </Button>
                              }
                              autofocusTarget="first-node"
                              onClose={() => {
                                setFormatOpen({
                                  type: 'price_mark',
                                  val:-1
                                });
                              }}
                            >
                              <Box
                                style={{ width: "80px", textAlign: "center" }}
                              >
                                <OptionList
                                  onChange={(val) => {
                                    handlePriceMark(0,'price_mark',Number(val[0]))
                                  }}
                                  selected={[Number(pageData?.advanced_rule?.basic_price?.price_mark)]}
                                  options={options}
                                />
                              </Box>
                            </Popover>
                          </Box>
                          <Box className="price_coefficient_input">
                            <TextField value={pageData?.advanced_rule?.basic_price?.price_factor}
                             onBlur={(e)=>{
                              onChangePriceBlur(0,'price_factor',e.target.value)}
                            }
                             onChange={(val) => {
                              onChangePrice(0,'price_factor',val)
                            }} />
                          </Box>
                          {showShippFee ? <Box>
                            <Button>
                              <span
                                style={{ fontWeight: "450", fontSize: "16px" }}
                              >
                                +
                              </span>
                            </Button>
                          </Box>:''}
                          {showShippFee ? <Box>
                            <span className="price_coefficient_badge">
                              <Badge tone="info"><span className='color2_price'>Shipping fee</span></Badge>
                            </span>
                          </Box>:''}
                        </InlineStack>
                      </Box>
                      {showOriginal ? <Box>
                        <InlineStack gap={100} blockAlign="center">
                          <span>Original price =</span>
                          <span className="price_coefficient_badge">
                            <Badge tone="info"><span className='color1_price'>Product cost</span></Badge>
                          </span>
                          <Box className="price_coefficient_operator">
                            <Popover
                              active={formatOpen?.type === 'compared_price_mark' && formatOpen?.val === 998}
                              activator={
                                <Button
                                  disclosure="select"
                                  onClick={() => {
                                    setFormatOpen({
                                      type: 'compared_price_mark',
                                      val:998
                                    });
                                  }}
                                >
                                   {Number(pageData?.advanced_rule?.basic_price?.compared_price_mark)  === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                                </Button>
                              }
                              autofocusTarget="first-node"
                              onClose={() => {
                                setFormatOpen({
                                  type: 'compared_price_mark',
                                  val:-1
                                });
                              }}
                            >
                              <Box
                                style={{ width: "80px", textAlign: "center" }}
                              >
                                <OptionList
                                 onChange={(val) => {
                                  handlePriceMark(0,'compared_price_mark',Number(val[0]))
                                }}
                                  selected={[Number(pageData?.advanced_rule?.basic_price?.compared_price_mark)]}
                                  options={options}
                                />
                              </Box>
                            </Popover>
                          </Box>
                          <Box className="price_coefficient_input">
                            <TextField value={pageData?.advanced_rule?.basic_price?.compared_price_factor} 
                            onBlur={(e)=>{
                              onChangePriceBlur(0,'compared_price_factor',e.target.value)}
                            }
                             onChange={(val) => {
                              onChangePrice(0,'compared_price_factor',val)
                                }} />
                          </Box>
                          {showShippFee ? <Box>
                            <Button>
                              <span
                                style={{ fontWeight: "450", fontSize: "16px" }}
                              >
                                +
                              </span>
                            </Button>
                          </Box>:""}
                          {showShippFee ? <Box>
                            <span className="price_coefficient_badge">
                              <Badge tone="info"><span className='color2_price'>Shipping fee</span></Badge>
                            </span>
                          </Box>:''}
                        </InlineStack>
                      </Box>:''}
                    </BlockStack>
                  </Box>
                </Card>}
            </BlockStack>
          </Box>
        </Card>
        {showPrice ? <BlockStack gap={400}>
          {pageData?.advanced_rule?.price_range?.cost_range?.map((item,ind)=><Card key={ind} padding={0} roundedAbove="xs">
          <Box
            style={{ background: "rgba(247, 247, 247, 1)", padding: "16px" }}
          >
            <BlockStack gap={400}>
              <Box>
              <BlockStack gap={200}>
                <InlineStack gap={100} blockAlign="center">
                  <Box>When</Box>
                  <Box style={{ width: "120px" }}>
                    <TextField 
                    value={item?.Start_Range_Value}
                    prefix="$" 
                    onChange={(val) => {handlePriceRange(ind,'Start_Range_Value',val)}}
                     />
                  </Box>
                  <Box>
                    <Button>
                      <span style={{ fontWeight: "450", fontSize: "16px" }}>
                        ≤
                      </span>
                    </Button>
                  </Box>
                  <Box>
                    <span className="price_coefficient_badge">
                      <Badge tone="success"><span className='color1_price'>Product cost</span></Badge>
                    </span>
                  </Box>
                  <Box>
                    <Button>
                      <span style={{ fontWeight: "450", fontSize: "16px" }}>
                        ≤
                      </span>
                    </Button>
                  </Box>
                  <Box style={{ width: "120px" }}>
                    <TextField value={item?.End_Range_Value} prefix="$" onChange={(val) => {handlePriceRange(ind,'End_Range_Value',val)}} />
                  </Box>
                </InlineStack>
                {(isCostError.index ===ind && isCostError.tip !=='') && (
                  <Banner tone="warning" title="">
                    {isCostError.tip}
                  </Banner>
                )
                }
                </BlockStack>
              </Box>
              <Card roundedAbove="xs">
                <Box>
                  <BlockStack gap={300}>
                    <Box>
                      <InlineStack gap={100} blockAlign="center">
                        <span>Selling price =</span>
                        <span className="price_coefficient_badge">
                          <Badge tone="info"><span className='color1_price'>Product cost</span></Badge>
                        </span>
                        <Box className="price_coefficient_operator">
                          <Popover
                            active={formatOpen?.type === 'price_mark' && formatOpen?.val === ind}
                            activator={
                              <Button
                                disclosure="select"
                                onClick={() => {
                                  setFormatOpen({
                                    type: 'price_mark',
                                    val:ind
                                  });
                                }}
                              >
                               {Number(item?.Factor_Mark) === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                              </Button>
                            }
                            autofocusTarget="first-node"
                            onClose={() => {
                              setFormatOpen({
                                type: '',
                                val:-1
                              });
                            }}
                          >
                            <Box style={{ width: "80px", textAlign: "center" }}>
                              <OptionList
                                onChange={(val) => {
                                  handlePriceMark(ind,'Factor_Mark',Number(val[0]))
                                }}
                                selected={[Number(item?.Factor_Mark)]}
                                options={options}
                              />
                            </Box>
                          </Popover>
                        </Box>
                        <Box className="price_coefficient_input">
                          <TextField 
                          value={item?.Factor_Value}
                          onBlur={(e)=>{onChangePriceBlur(ind,'Factor_Value',e.target.value)}}
                          onChange={(e) => {
                            onChangePrice(ind,'Factor_Value',e)
                          }} />
                        </Box>
                        {showShippFee ? <Box>
                          <Button>
                            <span
                              style={{ fontWeight: "450", fontSize: "16px" }}
                            >
                              +
                            </span>
                          </Button>
                        </Box>:""}
                        {showShippFee ? <Box>
                          <span className="price_coefficient_badge">
                            <Badge tone="info"><span className='color2_price'>Shipping fee</span></Badge>
                          </span>
                        </Box>:''}
                      </InlineStack>
                    </Box>
                    {showOriginal ? <Box>
                      <InlineStack gap={100} blockAlign="center">
                        <span>Original price =</span>
                        <span className="price_coefficient_badge">
                          <Badge tone="info"><span className='color1_price'>Product cost</span></Badge>
                        </span>
                        <Box className="price_coefficient_operator">
                          <Popover
                            active={formatOpen?.type === 'compare_mark' && formatOpen?.val === ind}
                            activator={
                              <Button
                                disclosure="select"
                                onClick={() => {
                                  setFormatOpen({
                                    type: 'compare_mark',
                                    val:ind
                                  });
                                }}
                              >
                                 {Number(item?.ComparedPrice_Factor_Mark) === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                              </Button>
                            }
                            autofocusTarget="first-node"
                            onClose={() => {
                              setFormatOpen({
                                type: 'compare_mark',
                                val:-1
                              });
                            }}
                          >
                            <Box style={{ width: "80px", textAlign: "center" }}>
                              <OptionList
                                onChange={(val) => {
                                  handlePriceMark(ind,'ComparedPrice_Factor_Mark',Number(val[0]))
                                }}
                                selected={[Number(item?.ComparedPrice_Factor_Mark)]}
                                options={options}
                              />
                            </Box>
                          </Popover>
                        </Box>
                        <Box className="price_coefficient_input">
                          <TextField value={item?.ComparedPrice_Factor_Value} onBlur={(e)=>{
                          onChangePriceBlur(ind,'ComparedPrice_Factor_Value',e.target.value)}}
                          onChange={(e) => {
                          onChangePrice(ind,'ComparedPrice_Factor_Value',e)
                          }}  />
                        </Box>
                        {showShippFee ? <Box>
                          <Button>
                            <span
                              style={{ fontWeight: "450", fontSize: "16px" }}
                            >
                              +
                            </span>
                          </Button>
                        </Box>:''}
                        {showShippFee ? <Box>
                          <span className="price_coefficient_badge">
                            <Badge tone="info"><span className='color2_price'>Shipping fee</span></Badge>
                          </span>
                        </Box>:''}
                      </InlineStack>
                    </Box>:''}
                    <Box>
                      <InlineStack gap={100}>
                        <Tooltip content="Delete">
                          <Button
                            disabled={pageData?.advanced_rule?.price_range?.cost_range?.length <= 1}
                            variant="tertiary"
                            icon={MinusCircleIcon}
                            onClick={()=>handlePriceItemRemove(ind)}
                          ></Button>
                        </Tooltip>
                        <Tooltip content="Copy">
                          <Button
                            disabled={pageData?.advanced_rule?.price_range?.cost_range?.length >= 10}
                            variant="tertiary"
                            icon={DuplicateIcon}
                            onClick={()=>handleCopyPriceRange(item)}
                          ></Button>
                        </Tooltip>
                      </InlineStack>
                    </Box>
                  </BlockStack>
                </Box>
              </Card>
            </BlockStack>
          </Box>
        </Card>)}
        </BlockStack>:<Box>
        </Box>}
       
        {showPrice ? <Box style={{ lineHeight: 1 }}>
          <Button disabled={pageData?.advanced_rule?.price_range?.cost_range.length >=10} variant="plain" icon={PlusIcon} onClick={()=>handleAddPriceRange()}>
          Add Tier
          </Button>
        </Box>:''}
        {showPrice ? <Box>
          <Card padding={0} roundedAbove="xs">
            <Box
              style={{ background: "rgba(247, 247, 247, 1)", padding: "16px" }}
            >
              <BlockStack gap={300}>
                <InlineStack>
                  <Tooltip
                    content="All price ranges except those already set"
                    hasUnderline
                  >
                    <Text variant="headingSm" as="h6">
                    Rest of the price range
                    </Text>
                  </Tooltip>
                  <span></span>
                </InlineStack>
                <Card roundedAbove="xs">
                  <Box>
                    <BlockStack gap={400}>
                      <Box>
                        <InlineStack gap={100} blockAlign="center">
                          <span>Selling price =</span>
                          <span className="price_coefficient_badge">
                            <Badge tone="info"><span className='color1_price'>Product cost</span></Badge>
                          </span>
                          <Box className="price_coefficient_operator">
                            <Popover
                              active={formatOpen?.type === 'Factor_Mark' && formatOpen?.val === 999}
                              activator={
                                <Button
                                  disclosure="select"
                                  onClick={() => {
                                    setFormatOpen({
                                      type: 'Factor_Mark',
                                      val:999
                                    });
                                  }}
                                >
                                  {Number(pageData?.advanced_rule?.price_range?.rest_range?.Factor_Mark)  === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                                </Button>
                              }
                              autofocusTarget="first-node"
                              onClose={() => {
                                setFormatOpen({
                                  type: 'Factor_Mark',
                                  val:-1
                                });
                              }}
                            >
                              <Box
                                style={{ width: "80px", textAlign: "center" }}
                              >
                                <OptionList
                                  onChange={(val) => {
                                    handlePriceMark(0,'Factor_Mark',Number(val[0]),'rest_range')
                                  }}
                                  selected={[Number(pageData?.advanced_rule?.price_range?.rest_range?.Factor_Mark)]}
                                  options={options}
                                />
                              </Box>
                            </Popover>
                          </Box>
                          <Box className="price_coefficient_input">
                            <TextField value={pageData?.advanced_rule?.price_range?.rest_range?.Factor_Value}  onBlur={(e)=>{
                              onChangePriceBlur(0,'Factor_Value',e.target.value,'reset_range')}}
                              onChange={(e) => {
                              onChangePrice(0,'Factor_Value',e,'reset_range')
                              }} />
                          </Box>
                          {showShippFee ? <Box>
                            <Button>
                              <span
                                style={{ fontWeight: "450", fontSize: "16px" }}
                              >
                                +
                              </span>
                            </Button>
                          </Box>:''}
                          {showShippFee ? <Box>
                            <span className="price_coefficient_badge">
                              <Badge tone="info"><span className='color2_price'>Shipping fee</span></Badge>
                            </span>
                          </Box>:''}
                        </InlineStack>
                      </Box>
                      {showOriginal ? <Box>
                        <InlineStack gap={100} blockAlign="center">
                          <span>Original price =</span>
                          <span className="price_coefficient_badge">
                            <Badge tone="info"><span className='color1_price'>Product cost</span></Badge>
                          </span>
                          <Box className="price_coefficient_operator">
                            <Popover
                              active={formatOpen?.type === 'ComparedPrice_Factor_Mark' && formatOpen?.val === 999}
                              activator={
                                <Button
                                  disclosure="select"
                                  onClick={() => {
                                    setFormatOpen({
                                      type: 'ComparedPrice_Factor_Mark',
                                      val:999
                                    });
                                  }}
                                >
                                   {Number(pageData?.advanced_rule?.price_range?.rest_range?.ComparedPrice_Factor_Mark)  === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                                </Button>
                              }
                              autofocusTarget="first-node"
                              onClose={() => {
                                setFormatOpen({
                                  type: 'ComparedPrice_Factor_Mark',
                                  val:-1
                                });
                              }}
                            >
                              <Box
                                style={{ width: "80px", textAlign: "center" }}
                              >
                                <OptionList
                                 onChange={(val) => {
                                  handlePriceMark(0,'ComparedPrice_Factor_Mark',Number(val[0]),'rest_range')
                                }}
                                  selected={[Number(pageData?.advanced_rule?.price_range?.rest_range?.ComparedPrice_Factor_Mark)]}
                                  options={options}
                                />
                              </Box>
                            </Popover>
                          </Box>
                          <Box className="price_coefficient_input">
                            <TextField value={pageData?.advanced_rule?.price_range?.rest_range?.ComparedPrice_Factor_Value} 
                            onBlur={(e)=>{
                              onChangePriceBlur(0,'ComparedPrice_Factor_Value',e.target.value,'reset_range')}}
                              onChange={(e) => {
                              onChangePrice(0,'ComparedPrice_Factor_Value',e,'reset_range')
                              }} />
                          </Box>
                          {showShippFee ? <Box>
                            <Button>
                              <span
                                style={{ fontWeight: "450", fontSize: "16px" }}
                              >
                                +
                              </span>
                            </Button>
                          </Box>:""}
                          {showShippFee ? <Box>
                            <span className="price_coefficient_badge">
                              <Badge tone="info"><span className='color2_price'>Shipping fee</span></Badge>
                            </span>
                          </Box>:""}
                        </InlineStack>
                      </Box>:''}
                    </BlockStack>
                  </Box>
                </Card>
              </BlockStack>
            </Box>
          </Card>
        </Box>:''}
        <Card roundedAbove="xs">
          <BlockStack gap={300}>
            <InlineStack align="space-between">
              <Tooltip
                content='You can specify a fixed cent value for your retail prices. This value will be applied when calculating the final price of your items. For example, to set your product price to end with ".99", enter "99" in the field below.'
                hasUnderline
              >
                <Text variant="headingSm" as="h6">
                Price Ending Settings
                </Text>
              </Tooltip>
              <Box>
                <SwitchButton open={pageData?.advanced_rule?.assign_cents?.switch} handleSwitch={() => {
                  setPageData((prev)=>({
                    ...prev,
                    advanced_rule: {
                      ...prev?.advanced_rule,
                      assign_cents: {
                        ...prev?.advanced_rule?.assign_cents,
                        switch: prev?.advanced_rule?.assign_cents?.switch ? 0 : 1
                      }
                    }
                  }))
                }} />
              </Box>
            </InlineStack>
            <InlineStack gap={400}>
              <Box className="test_in_price">
                <TextField label="Price Ending" 
                disabled={!pageData?.advanced_rule?.assign_cents?.switch} 
                value={pageData?.advanced_rule?.assign_cents?.price} 
                onChange={(val) => {
                  let input = val;
                  if (input === "") {
                    setPageData((prev) => ({
                      ...prev,
                      advanced_rule:{
                        ...prev.advanced_rule,
                        assign_cents:{
                          ...prev.advanced_rule.assign_cents,
                          price:input
                        }
                      }
                    }));
                    return;
                  }
                  // 检查是否为数字
                  if (!/^\d+$/.test(input)) {
                    return;
                  }
              
                  let num = parseInt(input, 10);
                  if (!(num < 0 || num > 99)) {
                    setPageData((prev) => ({
                      ...prev,
                      advanced_rule:{
                        ...prev.advanced_rule,
                        assign_cents:{
                          ...prev.advanced_rule.assign_cents,
                          price:num
                        }
                      }
                    }));
                  } 
                }}
                onBlur={(e)=>{
                  if (e.target.value === "") {
                    setPageData((prev) => ({
                      ...prev,
                      advanced_rule:{
                        ...prev.advanced_rule,
                        assign_cents:{
                          ...prev.advanced_rule.assign_cents,
                          price:0
                        }
                      }
                    }));
                    return;
                  }
                }}
                />
              </Box>
              <Box className="test_in_price">
                <TextField
                  label="Original Price Ending"
                  disabled={!pageData?.advanced_rule?.assign_cents?.switch}
                  value={pageData?.advanced_rule?.assign_cents?.compared_price}
                  onChange={(val) => {
                    let input = val;
                    if (input === "") {
                      setPageData((prev) => ({
                        ...prev,
                        advanced_rule:{
                          ...prev.advanced_rule,
                          assign_cents:{
                            ...prev.advanced_rule.assign_cents,
                            compared_price:input
                          }
                        }
                      }));
                      return;
                    }
                    // 检查是否为数字
                    if (!/^\d+$/.test(input)) {
                      return;
                    }
                
                    let num = parseInt(input, 10);
                    if (!(num < 0 || num > 99)) {
                      setPageData((prev) => ({
                        ...prev,
                        advanced_rule:{
                          ...prev.advanced_rule,
                          assign_cents:{
                            ...prev.advanced_rule.assign_cents,
                            compared_price:num
                          }
                        }
                      }));
                    } 
                  }}
                  onBlur={(e)=>{
                    if (e.target.value === "") {
                      setPageData((prev) => ({
                        ...prev,
                        advanced_rule:{
                          ...prev.advanced_rule,
                          assign_cents:{
                            ...prev.advanced_rule.assign_cents,
                            compared_price:0
                          }
                        }
                      }));
                      return;
                    }
                  }}
                />
              </Box>
            </InlineStack>
          </BlockStack>
        </Card>
        <Card roundedAbove="xs">
          <BlockStack gap={300}>
            <Box>
              <Badge>
                <InlineStack blockAlign="center" gap={100}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "8px",
                      height: "8px",
                      background: "rgb(4, 123, 93)",
                      borderRadius: "2px",
                    }}
                  ></span>
                  Test it out
                </InlineStack>
              </Badge>
            </Box>
            <Box>
              <InlineStack gap={400}>
                <Box className="test_in_price">
                  <TextField
                    label="Product Cost"
                    prefix="$"
                    value={testPrice.cost}
                    onBlur={(e)=>{
                      onChangeTestPriceBlur('cost',e.target.value)
                    }}
                    onChange={(val) => {
                      onChangeTestPrice('cost',val)
                    }}
                  />
                </Box>
                {showShippFee ? <Box className="test_in_price">
                  <TextField
                    label="Shipping fee"
                    prefix="$"
                    value={testPrice.fee}
                    onBlur={(e)=>{
                      onChangeTestPriceBlur('fee',e.target.value)
                    }}
                    onChange={(val) => {
                      onChangeTestPrice('fee',val)
                    }}
                  />
                </Box>:''}
              </InlineStack>
            </Box>
            <Box>
              <Card roundedAbove="xs">
                <InlineStack gap={200} wrap={false}>
                  <Box style={{ width: "48px" }}>
                    <Thumbnail
                     source="/order_fulfillment/test_price_image.png"
                      alt="Black choker necklace"
                    />
                  </Box>
                  <Box>
                    <Box className="price-box-name">
                      Stylish Personality Alphabet Printed Bouquet Pocket
                    </Box>
                    <Box className="price-box-mobile">
                      <InlineStack>
                        <Box>
                          <Text variant="headingSm" as="h6">
                            Selling price: {handleExamplePrice('cost')}
                          </Text>
                        </Box>
                        {showOriginal ? <Box className="price_coefficient_original_price">
                          <Text variant="headingSm" as="h6">
                            Original price: {handleExamplePrice('original')}
                          </Text>
                        </Box>:''}
                      </InlineStack>
                    </Box>
                  </Box>
                </InlineStack>
                <Box className="price-box-pc">
                      <InlineStack>
                        <Box>
                          <Text variant="headingSm" as="h6">
                            Selling price: {handleExamplePrice('cost')}
                          </Text>
                        </Box>
                        {showOriginal ? <Box className="price_coefficient_original_price">
                          <Text variant="headingSm" as="h6">
                            Original price: {handleExamplePrice('original')}
                          </Text>
                        </Box>:''}
                      </InlineStack>
                    </Box>
              </Card>
            </Box>
          </BlockStack>
        </Card>
      </BlockStack>
    </Box>
  );
};

export default BasicPriceBox;
